import { useVueLoaderStore } from "@/stores/vueLoader";
import axios from "axios";

// Dev: palert
const palertAPI = "https://palert.earth.sinica.edu.tw/";
// const palertAPI = "http://palert.earth.sinica.edu.tw:8003/graphql/";
// const palertAPI = "http://192.168.211.99:8000/";
// const palertAPI = "http://140.109.80.93:8003/";
// const palertAPI = "http://140.109.80.93:8000/";

const instance = axios.create({
  baseURL: palertAPI,
  // headers: { "Content-Type": "application/json" },
  // responseType: "blob",
});

// ------ DEBUG：HTTP 計時 / 輸出大小 -------------------------------------------------
// function prettySize(obj: any) {
//   try {
//     const len = JSON.stringify(obj)?.length ?? 0;
//     if (len > 1e6) return `${(len / 1e6).toFixed(2)}MB`;
//     if (len > 1e3) return `${(len / 1e3).toFixed(1)}KB`;
//     return `${len}B`;
//   } catch { return "n/a"; }
// }
// -----------------------------------------------------------------------------------

// Request
instance.interceptors.request.use(
  (req) => {
    // 記錄時間戳
    (req as any).__t0 = performance.now();

    // 非即時資料才打開全域 loader
    const isRealtime = req?.data?.variables?.hasOwnProperty?.("recordTime");
    if (!isRealtime) useVueLoaderStore().setActive(true);

    // 簡要列出要打的 endpoint 與變數（安全起見只印 variables）
    // try {
    //   const vars = req?.data?.variables ?? req?.data ?? null;
    //   const method = (req.method || "GET").toUpperCase();
    //   console.log(`[http] → ${method} ${req.baseURL ?? ""}${req.url}`, vars);
    // } catch {}

    return req;
  },
  (error) => {
    useVueLoaderStore().setActive(false);
    return Promise.reject(error);
  }
);

// Response
instance.interceptors.response.use(
  (response) => {
    useVueLoaderStore().setActive(false);

    // const t0 = (response.config as any).__t0 ?? performance.now();
    // const ms = Math.round(performance.now() - t0);
    // const method = (response.config.method || "GET").toUpperCase();
    // const url = response.config.url;
    // console.log(
    //   `[http] ← ${response.status} ${method} ${url} (${ms}ms, ~${prettySize(response.data)})`
    // );

    return response;
  },
  (error) => {
    useVueLoaderStore().setActive(false);

    // const cfg = error?.config ?? {};
    // const t0 = (cfg as any).__t0 ?? performance.now();
    // const ms = Math.round(performance.now() - t0);
    // const method = (cfg.method || "GET").toUpperCase();
    // const url = cfg.url;

    // const status = error?.response?.status;
    // const body = error?.response?.data;
    // console.warn(
    //   `[http:ERR] ${method} ${url} (${ms}ms)`,
    //   status ? `status=${status}` : "",
    //   body ?? error?.message
    // );

    return Promise.reject(error);
  }
);

export default instance;

